import React from 'react'
import classes from './InstructionItem.module.sass'
import { Instruction } from '../../../../common/types/interfaces'
import ScreenItem from './components/screenItem/ScreenItem'

type Props = {
  item: Instruction
  showScreenModal: (image: string) => void
}

export const InstructionItem = ({ item, showScreenModal }: Props) => {
  return (
    <div className={classes.Container}>
      <div className={classes.TextSection}>
        <div className={classes.Title}>{item.title}</div>
        <div className={classes.Description}>{item.description}</div>
      </div>
      {item.images.length > 0 && (
        <div className={classes.Screens}>
          {item.images.map((el) => (
            <ScreenItem image={el} showScreenModal={showScreenModal} />
          ))}
        </div>
      )}
    </div>
  )
}
